module.exports = __webpack_public_path__ + "img/sj-3.31745f3d.png";